var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconEllipsis = function SvgIconEllipsis(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 24,
    viewBox: "0 0 6 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#979797",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.802C0 1.254 1.254 0 2.802 0c1.547 0 2.801 1.254 2.801 2.802 0 1.547-1.254 2.801-2.801 2.801C1.254 5.603 0 4.35 0 2.802zm2.802 6.396C1.254 9.198 0 10.453 0 12c0 1.547 1.254 2.802 2.802 2.802 1.547 0 2.801-1.255 2.801-2.802 0-1.547-1.254-2.802-2.801-2.802zm0 9.199C1.254 18.397 0 19.65 0 21.198 0 22.746 1.254 24 2.802 24c1.547 0 2.801-1.254 2.801-2.802 0-1.547-1.254-2.801-2.801-2.801z",
    transform: "translate(-494 -91) translate(-30060 -1481) translate(30554 1572)"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconEllipsis);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-ellipsis.2c7655977b2965653e9ac3641bd104fa.svg";